import 'mburger-webcomponent/dist/mburger/index';
import {getSectionCookie} from "./sections/section-cookie";
import Mmenu from "mmenu-js";

export default function initializeMobileMenu() {
    const section = getSectionCookie();
    console.log(section);
    const mobileMenu = new Mmenu('#mobile-menu',
        {
        theme: 'white',
        navbars: [
            {
                "position": "top",
                "type": "tabs",
                "content": [
                    "<a href='/' data-section='he' class='" + (section === 'he' ? 'active' : '') + " run-preloader'>On</a>",
                    "<a href='/ona' data-section='she' class='" + (section === 'she' ? 'active' : '') + " run-preloader'>Ona</a>"
                ]
            },
        ],
    },
        {
            classNames: {
                selected: "current-menu-item"
            }
        }
    );

    const mobileMenuApi = mobileMenu.API;


    // sprawdzanie czy body ma klasę modal-open i jeśli się taka pojawi to zamykamy menu mobilne jeśli jest otwarte
    document.querySelector('body').addEventListener('modal-open', function (e) {
       mobileMenuApi.close();
    });


    document.querySelectorAll('#mobile-menu .mm-navbar__tab').forEach(function (item) {

        item.classList.remove('mm-navbar__tab--selected');
        item.ariaExpanded = false;

        if (item.dataset.section === section) {
            item.classList.add('mm-navbar__tab--selected');
            item.ariaExpanded = true;
        }
    });

    document.querySelectorAll('#mobile-menu-he,#mobile-menu-she').forEach(function (item) {
        document.querySelectorAll('#mobile-menu-he,#mobile-menu-she')
        if(item.classList.contains('mm-panel--opened')) {
            item.classList.remove('mm-panel--opened');
            item.inert = true;
            if (item.id === 'mobile-menu-' + section) {
                if(!item.classList.contains('mm-panel--parent')) {
                    item.classList.add('mm-panel--opened');
                    item.inert = false;
                }

            }
        }
    });

    document.querySelectorAll('#mobile-menu-he,#mobile-menu-she').forEach(function (item) {
        document.querySelectorAll('#mobile-menu-he,#mobile-menu-she')
        if(item.classList.contains('mm-panel--opened')) {
            item.classList.remove('mm-panel--opened');
            item.inert = true;
            if (item.id === 'mobile-menu-' + section) {
                if(!item.classList.contains('mm-panel--parent')) {
                    item.classList.add('mm-panel--opened');
                    item.inert = false;
                }

            }
        }
    });


    // jeśli żadne menu mobilne nie jest uruchomione to uruchamiamy odpowiednie do sekcji
    if (!document.querySelector('#mobile-menu-he.mm-panel--opened') && !document.querySelector('#mobile-menu-she.mm-panel--opened')) {
        console.log('no mobile menu opened');
        document.querySelector('#mobile-menu-' + section).classList.add('mm-panel--opened');
        document.querySelector('#mobile-menu-' + section).inert = false;
    } else{
        console.log('mobile menu opened');
    }




}
